import Api from '../../api/Api'

const trainer = {
  //set namespace true
  namespaced: true,
  state: {
    nama_event: '',
    penilaian: {},
    siswa: [],
    rubrik: [],
    comingsoon: [],
    comingsoon_aktifitas: [],
    event_trainer: [],
    event_trainer_detail_overview: {},
    event_trainer_detail_analytic: {},
    empty: '',
  },
  mutations: {
    SET_EVENT(state, data) {
      state.event_trainer = data
    },
    SET_COMINGSOON(state, data) {
      state.comingsoon = data
    },
    SET_COMINGSOON_AKTIFITAS(state, data) {
      state.comingsoon_aktifitas = data
    },
    SET_EVENT_DETAIL_OVERVIEW(state, data) {
      state.event_trainer_detail_overview = data
    },
    SET_EVENT_DETAIL_ANALYTIC(state, data) {
      state.event_trainer_detail_analytic = data
    },
    SET_NAMA_EVENT_TRAINER(state, data) {
      state.nama_event = data
    },
    SET_EVENT_SISWA(state, data) {
      state.siswa = data
    },
    SET_EVENT_DETAIL_RUBRIK(state, data) {
      state.rubrik = data
    },
    SET_PENILAIAN(state, data) {
      state.penilaian = data
    },
    SET_EMPTY_RUBRIK(state, res) {
      state.rubrik = []
    },
    SET_EMPTY(state, data) {
      state.empty = data
    },
  },
  actions: {
    list_event({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/eventTrainer?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&start=${data.start}&end=${data.end}&topik=${data.topik}&is_finish=${data.is_finish}`,
        )
          .then((response) => {
            commit('SET_EVENT', response.data.data.data)
            console.log(response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    historyTarikSaldo({}, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/history-tarik-saldo?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    transaksiTrainer({}, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/transaksi-trainer?page=${data.page}&per_page=${data.per_page}&id_event=${data.id_event}&id_batch=${data.id_batch}&status=${data.status}&start=${data.start}&end=${data.end}&search=${data.search}`,
        )
          .then((response) => {
            console.log(response.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    exportHistory({}, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/trainer/export-history-withdrawal?selected=${data.selected}&search=${data.search}&status=${data.status}&start=${data.start}&end=${data.end}`,
          { responseType: 'blob' },
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detailEvent({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/detailEvent/${data.id}?id_batch=${data.id_batch}&page=${data.page}&per_page=${data.per_page}&search=${data.search}`,
        )
          .then((response) => {
            commit('SET_EVENT_DETAIL_OVERVIEW', response.data.data.overview)
            commit('SET_EVENT_DETAIL_ANALYTIC', response.data.data.analytic)
            commit('SET_EVENT_DETAIL_RUBRIK', response.data.data.rubrik)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail_event_trainer({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`trainer/detail_event_trainer/${data.id}`)
          .then((response) => {
            commit('SET_NAMA_EVENT_TRAINER', response.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    saldo({}, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/payment?status=${data.status}&start=${data.start}&end=${data.end}`,
        )
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addTrainer({}, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/add-user-trainer`, data.create)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDetailMateri({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`trainer/getDetailMateri?id_event=${data.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getRubrik({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`trainer/loadRubrik?id_event=${data.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getSoal({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`trainer/loadSoal?id_event=${data.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    comingsoon({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `trainer/dashboard/comingsoon?page=${data.page}&per_page=${data.per_page}&page2=${data.page2}&per_page2=${data.per_page2}`,
        )
          .then((response) => {
            commit('SET_COMINGSOON', response.data.data.data)
            commit('SET_COMINGSOON_AKTIFITAS', response.data.aktifitas.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    penilaian({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`trainer/event/penilaian?id_aktifitas=${data.id_aktifitas}`)
          .then((response) => {
            commit('SET_PENILAIAN', response.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubah_nilai({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/event/bypass_nilai/${data.id_aktifitas}`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addKriteria({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/addKriteria`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    simpanPembagianSoal({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/simpan_pembagian_soal`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    jawabstudykasus({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`quiz/userquizstudykasustrainermenjawab`, data)
          .then((response) => {
            if (data.submit) {
              commit('SET_EMPTY_RUBRIK', '')
            }
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    create_soal({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/create_soal`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    setting({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/setting`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapusRubrik({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/hapus_rubrik_intruksi`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapusSoal({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`trainer/hapus_soal`, data)
          .then((response) => {
            commit('', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {
    getEvent(state) {
      return state.event_trainer
    },
    getEventDetailOverview(state) {
      return state.event_trainer_detail_overview
    },
    getEventDetailAnalytic(state) {
      return state.event_trainer_detail_analytic
    },
    getNamaEvent(state) {
      return state.nama_event
    },
    getComingSoon(state) {
      return state.comingsoon
    },
    getComingSoonAktifitas(state) {
      return state.comingsoon_aktifitas
    },
    getSiswa(state) {
      return state.siswa
    },
    getRubrik(state) {
      return state.rubrik
    },
    getPenilaian(state) {
      return state.penilaian
    },
  },
}

export default trainer
